import { DatePicker, List } from "antd";
import styles from "./ProblemReport.module.css";
import { FaCalendarAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AntdDropdown, SearchInput } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import InfoPagesMiddleware from "../../store/Middlewares/InfoPagesMiddleware";
import moment from "moment";
import AlertAction from "../../store/Actions/AlertActions";
import { MdSearch } from "react-icons/md";

const ProblemReport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [SelectedLocation, setSelectedLocation] = useState('');
  const [allLocations, setallLocations] = useState();
  const [dateFrom, setdateFrom] = useState('')
  const [dateFromModal, setdateFromModal] = useState(false)
  const [dateTo, setdateTo] = useState('')
  const [dateToModal, setdateToModal] = useState(false)
  const [date, setDate] = useState(new Date())
  const { t, i18n } = useTranslation();
  const ProblemReportList = useSelector(state => state.ProblemReportingReducer.ProblemReporting)
  const ProblemReportListPagination = useSelector(state => state.ProblemReportingReducer.ProblemReportingPagination)

  useEffect(() => {
    getProblemReport();
    getAllLocations();
    getLanguage();
  }, [])

  const getProblemReport = () => {
    let data = {
      location_id: SelectedLocation,
      date_from: dateFrom,
      date_to: dateTo,
      next_page_url: undefined
    }
    dispatch(InfoPagesMiddleware.getProblemReporting(data))
  }

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };


  const getAllLocations = () => {
    dispatch(InfoPagesMiddleware.getLocation())
      .then((data) => {
        setallLocations(data?.data)
      })
      .catch((err) => {
        console.warn(err.message)
      })
  }

  const onSearchTimeSheetList = () => {
    if ((!dateFrom && !dateTo) || (dateFrom && dateTo)) {
      let data = {
        location_id: SelectedLocation,
        date_from: dateFrom,
        date_to: dateTo,
        next_page_url: undefined
      }
      dispatch(InfoPagesMiddleware.getProblemReporting(data))
        .then((data) => {
        })
    }
    else if ((dateFrom && !dateTo) || (dateTo && !dateFrom)) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: 'Please select date from and date to!' }))
      // Alert.alert('Note', 'Please select date from and date to!')
    }
  }


  const onPressLoadMore = () => {
    let data = {
      location_id: SelectedLocation,
      date_from: dateFrom,
      date_to: dateTo,
      next_page_url: ProblemReportListPagination?.links?.next,
    };
    dispatch(InfoPagesMiddleware.getProblemReporting(data));
  };

  const loadMore =
    ProblemReportListPagination?.links?.next ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
          display: 'flex', justifyContent: 'center'
        }}
      >
        <button onClick={onPressLoadMore} className={styles.loadMore_button}>
          Load More
        </button>
      </div>
    ) : null;

  const onChange = (date, dateString) => {
    console.log(date, dateString);
  };

  const handleChange = (value) => {
    console.log(value);
  };
  return (
    <div className={styles.mainCon}>
      <div className={styles.heading}>
        <h1>{t("Problem Report")}</h1>
      </div>
      <div className={styles.firstRow}>

        <div className={styles.firstRowCon}>
          <DatePicker
            className={'datePicker'}
            placeholder={t("Date From")}

            style={{
              height: 45
            }}
            suffixIcon={<FaCalendarAlt className={styles.calendarIcon} />}
            onChange={(date, dateString) => setdateFrom(dateString)}
          />
        </div>
        <div className={styles.firstRowCon}>
          <DatePicker
            className={'datePicker'}
            placeholder={t("Date To")}
            style={{
              height: 45
            }}
            suffixIcon={<FaCalendarAlt className={styles.calendarIcon} />}
            onChange={(date, dateString) => setdateTo(dateString)}
          />
        </div>
        <div className={styles.firstRowCon}>
          <AntdDropdown
            // name={'Status'}
            // label={'Role'}
            placeholder={t("Select Location")}
            className={"yellow_border_class"}
            onChange={(val) => setSelectedLocation(val)}
            options={
              allLocations?.map((item) => { return ({ value: item?.id, option: item?.address }) })
            }
            style={{ width: "100%", height: "20px", borderColor: "red" }}
          />
        </div>
      </div>
      <div className={styles.secondRow}>
        {/* <div className={styles.firstRowCon}>
          <AntdDropdown
            // name={'Status'}
            // label={'Role'}
            placeholder={"Select Customer"}
            className={"yellow_border_class"}
            onChange={handleChange}
            options={[
              { value: "Working", option: "Working" },
              { value: "Pending", option: "Pending" },
            ]}
            style={{ width: "100%", height: "20px", borderColor: "red" }}
          />
        </div>
        <div className={styles.firstRowCon}>
          <AntdDropdown
            // name={'Status'}
            // label={'Role'}
            placeholder={"Select Customer"}
            className={"yellow_border_class"}
            onChange={handleChange}
            options={[
              { value: "Working", option: "Working" },
              { value: "Pending", option: "Pending" },
            ]}
            style={{ width: "100%", height: "20px", borderColor: "red" }}
          />
        </div> */}
        <div className={styles.firstRowCon}>

          <button onClick={() => onSearchTimeSheetList()} className={styles.Search_button}>
            <MdSearch
              style={{ width: 20, height: 20 }}
              color={"#ffff"}
            />
            {t("Search")}
          </button>
        </div>
      </div>
      <List
        grid={{
          gutter: 16,
          //   xs: 2,
          sm: 1,
          md: 1,
          lg: 1,
          xl: 2,
          xxl: 2,
        }}
        className={styles.list}
        dataSource={ProblemReportList}
        footer={loadMore}
        renderItem={(item) => (
          <div
            key={item?.id}
            className={styles.listItem}
          // onClick={() =>
          //   navigate("/contractorHome/WeeklyInspection/Details", {
          //     state: { reportData: item },
          //   })
          // }
          >
            <div className={styles.header}>
              <div className={styles.listName}>
                <h1>{t("Report")} # {item?.id}</h1>
                <h3>{item?.date
                  ? moment(item?.date).format('MM-DD-YYYY')
                  : ''}</h3>
              </div>
              <div className={styles.jobID}>
                <p>Job Id {item?.id}</p>
              </div>
            </div>
            <div className={styles.Row}>
              <div className={styles.Col}>
                <span>{t("Location")}</span>
                <p>{item?.location?.address}</p>
              </div>
              <div className={styles.Col}>
                <span>{t("Sign In Time")}</span>
                <p>{moment(item?.sign_in_time).format('LT')}</p>
              </div>
              <div className={styles.Col}>
                <span>{t("Sign Out Time")}</span>
                <p>{moment(item?.sign_out_time).format('LT')}</p>
              </div>
            </div>
            <div className={styles.Row}>
              <div className={styles.Col}>
                <span>{t("Customer Name")}</span>
                <p>{item?.customer_name}</p>
              </div>
              <div className={styles.Col}>
                <span>{t("Cleaner Name")}</span>
                <p>{item?.cleaner_name}</p>
              </div>
              <div className={styles.Col}>
                <span>{t("Total Time")}</span>
                <p>{item?.total_hours}</p>
              </div>
            </div>
            <div className={styles.Row}>
              <div className={styles.ProblemReport}>
                <span>{t("Problem Report")}</span>
                <p>{item?.report_problem}</p>
              </div>
            </div>
          </div>
        )}
      />
    </div>
  );
};
export default ProblemReport;
